module.exports = __webpack_public_path__ + "static/img/torso17.1b1a5ba6.jpg";